import React from "react";
import KYCTable from "./KYCTable";

const KYCManagement = () => {
  return (
    <div className="p-6 flex flex-col gap-10">
      <p className="font-bold text-2xl">KYC Management</p>
      <KYCTable />
    </div>
  );
};

export default KYCManagement;
